import { Injectable } from '@angular/core';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class PassiveSegmentService {

  order;
  flights = [];
  passiveSegments = [];
  sabreNotAllowedAirlineCodes = ['BA', 'IB', 'VY', 'LH', 'LX', 'OS', 'SN', 'AF', 'AY', 'AV', 'WY', 'SV'];

  constructor() { }

  generate(format: 'amadeus' | 'sabre' | 'travelport', anonymizePassiveSegment = false) {
    this.flights = [];
    this.passiveSegments = [];
    this.getInfo();
    let segmentDelimiter = ';';

    switch (format) {
      case 'amadeus':
        this.preparePassiveSegment(format, segmentDelimiter, 'SS', 'GK', '/', anonymizePassiveSegment);
        break;
      case 'sabre':
        segmentDelimiter = '§';
        this.preparePassiveSegment(format, segmentDelimiter, '0', 'YK', this.order.pnr.length <= 6 ? '*' : '¥', anonymizePassiveSegment);
        break;
      case 'travelport':
        this.prepareTravelportPassiveSegment();
        break;
    }

    return this.passiveSegments.join(segmentDelimiter);
  }

  prepareTravelportPassiveSegment() {
    const flightSegments = this.flights.map((flight) => {
      return '0' +
        flight.airlineID +
        flight.flightNumber +
        flight.classOfService +
        moment(flight.departureDate).format('DDMMM').toUpperCase() +
        flight.departureAirportCode +
        flight.arrivalAirportCode +
        'YK' +
        this.order.passengers.length +
        `RL.YY*${this.order.pnr}`;
    });

    const allSegments = [
      ...flightSegments,
      ...this.generatePassengerSegments('travelport')
    ];

    const finalOutput = allSegments.join(';');
    this.passiveSegments.push(finalOutput);
  }

  preparePassiveSegment(
    format: 'amadeus' | 'sabre',
    segmentDelimiter: string,
    airSellEntry: string,
    ghostSegment: string,
    delimiter: string,
    anonymizePassiveSegment = false
  ) {
    const flightSegments = this.flights.map((flight) => {
      return airSellEntry +
        (anonymizePassiveSegment ? 'YY' : flight.airlineID) +
        flight.flightNumber +
        flight.classOfService +
        moment(flight.departureDate).format('DDMMM').toUpperCase() +
        flight.departureAirportCode +
        flight.arrivalAirportCode +
        ghostSegment +
        this.order.passengers.length +
        '/' +
        flight.departureTime.replace(':', '') +
        flight.arrivalTime.replace(':', '') +
        (flight.arrivalDate !== flight.departureDate ? '+1' : '') +
        delimiter +
        this.order.pnr;
    });

    const allSegments = [
      ...flightSegments,
      ...this.generatePassengerSegments(format)
    ];

    const finalOutput = allSegments.join(segmentDelimiter) + (format === 'sabre' ? segmentDelimiter : '');
    this.passiveSegments.push(finalOutput);
  }

  getInfo() {
    this.order?.flights.map(flight => {
      flight.segments.map((leg) => {
        let flightInfo = {};
        flightInfo['airlineID'] = leg.marketingCarrier.airlineID; // 2 characters
        flightInfo['flightNumber'] = leg.marketingCarrier.flightNumber;
        flightInfo['classOfService'] = leg.detail.classOfService.code; // always 1 letter
        flightInfo['departureDate'] = leg.originDestination.departure.date;
        flightInfo['arrivalDate'] = leg.originDestination.arrival.date;
        flightInfo['departureAirportCode'] = leg.originDestination.departure.airportCode;
        flightInfo['arrivalAirportCode'] = leg.originDestination.arrival.airportCode;
        flightInfo['departureTime'] = leg.originDestination.departure.time;
        flightInfo['arrivalTime'] = leg.originDestination.arrival.time;
        this.flights.push(flightInfo);
      });
    });
  }

  private generatePassengerSegments(format: 'amadeus' | 'sabre' | 'travelport'): string[] {
    const nameSegments = this.order.passengers.map(passenger => {
      const title = passenger.data.title ? ` ${passenger.data.title}` : '';
      const prefix = format === 'sabre' ? '-1' : format === 'travelport' ? 'N.1' : 'NM1';
      const birthdate = format === 'sabre' && passenger.data.birthdate
        ? `*${moment(passenger.data.birthdate).format('DDMMMYY').toUpperCase()}`
        : '';
      return `${prefix}${passenger.data.surname}/${passenger.data.name}${title}${birthdate}`;
    });

    const firstPassenger = this.order.passengers[0];
    const phone = firstPassenger?.data?.phone;
    const email = firstPassenger?.data?.email;

    const contactSegments =
      format === 'travelport'
        ? [email ? `MT.${email}` : '', phone ? `P.M*${phone}` : '']
        : format === 'amadeus'
          ? [email ? `APE-${email}` : '', phone ? `APM-${phone}` : '']
          : [email ? `PE¥${email}¥` : '', phone ? `9${phone}` : ''] ;

    return [...nameSegments, ...contactSegments.filter(Boolean)];
  }
}
